<div fxLayout="row" fxLayout.lt-md="column" class="profile-details-container" #progressContainer>
  <div fxLayout="column" fxFlex="48%" class="profile-details-block">
    <form [formGroup]="profileDetailsForm" class="profile-details-form">
      <form-input [control]="emailField"
                  label="Email"
                  i18n-label="Sign Up|Email input label@@sign-up-email-label"
                  placeholder="Your email..."
                  i18n-placeholder="Sign Up|Email input placeholder@@sign-up-email-placeholder"
                  matTooltip="Email cannot be edited"
                  i18n-matTooltip="User Profile|User profile email edit tooltip@@user-profile-email-edit-tooltip"
                  [matTooltipDisabled]="!user?.email"
                  autocomplete="email"
                  type="email"
                  [minLength]="5" [maxLength]="128"
                  [suffixButton]="emailChangeAllowed ? 'person_search' : undefined"
                  [suffixAction]="searchUserByEmail"
                  (focusLost)="searchUserByEmail()"></form-input>

      <div *ngIf="user && user.email && !user.emailVerified" class="email-not-verified-block" fxLayout="row">
        <div fxFlex="25px" class="warn-icon">
          <mat-icon color="warn">warning</mat-icon>
        </div>
        <div fxFlex="80%">
          <div i18n="User Profile|User profile email not verified title@@user-profile-email-not-verified-title"
               class="mat-body-strong">Email address is not verified.
          </div>
          <div i18n="User Profile|User profile email not verified details@@user-profile-email-not-verified-details"
               class="mat-small">You would not receive any notifications unless you verify your address.
          </div>
        </div>
        <div class="fill-space"></div>
        <div fxFlex="112px" class="verify-btn">
          <app-button color="accent"
                      label="Verify"
                      i18n-label="User Profile|User profile email verify button label@@user-profile-email-verify-button-label"
                      (clicked)="verifyEmail()"></app-button>
        </div>
      </div>

      <form-input [control]="phoneField"
                  [required]="!!role && requirePhone.includes(role)"
                  type="tel"
                  label="Phone"
                  i18n-label="Sign Up|Phone input label@@sign-up-phone-label"
                  placeholder="Your phone (format like +380000000000)..."
                  i18n-placeholder="Sign Up|Phone input placeholder@@sign-up-phone-placeholder"
                  autocomplete="tel"
                  [minLength]="7" [maxLength]="15"></form-input>
      <form-input [control]="firstNameField"
                  label="First Name"
                  i18n-label="Sign Up|First Name input label@@sign-up-first-name-label"
                  placeholder="Your first name..."
                  i18n-placeholder="Sign Up|First Name input placeholder@@sign-up-first-name-placeholder"
                  [matTooltip]="firstNameEditTooltipSocial + user?.provider"
                  [matTooltipDisabled]="!user || (user && !user.provider)"
                  autocomplete="given-name"
                  [minLength]="2" [maxLength]="128"></form-input>
      <form-input [control]="lastNameField"
                  label="Last Name"
                  i18n-label="Sign Up|Last Name input label@@sign-up-last-name-label"
                  placeholder="Your last name..."
                  i18n-placeholder="Sign Up|Last Name input placeholder@@sign-up-last-name-placeholder"
                  [matTooltip]="lastNameEditTooltipSocial + user?.provider"
                  [matTooltipDisabled]="!user || (user && !user.provider)"
                  autocomplete="family-name"
                  [minLength]="2" [maxLength]="128"></form-input>
      <form-input [control]="localeField"
                  label="Locale"
                  i18n-label="User Profile|Locale input label@@user-profile-locale-input-label"
                  [options]="locales"
                  [compareWith]="compareLocales"
                  [displayWith]="displayLocale"></form-input>

      <div class="save-actions full-width">
        <div class="fill-space"></div>
        <app-button color="primary"
                    width="172px"
                    label="Update Profile"
                    i18n-label="User Profile|User profile update button label@@user-profile-update-button-label"
                    [disabled]="!proceedAllowed()"
                    (clicked)="updateProfile()"></app-button>
      </div>
    </form>
  </div>

  <div class="fill-space"></div>

  <div fxLayout="column" fxFlex="48%" class="profile-details-block">
    <form-input *ngIf="role"
                [control]="roleField"
                class="role-filed"
                label="Role"
                i18n-label="Sign Up|Sign Up role input label@@sign-up-role-input-label"></form-input>
    <div class="profile-photo" fxLayout="row">
      <avatar *ngIf="user"
              [letters]="user.getAvatarLetters()"
              [picture]="user.picture"
              [largeAvatar]="true"></avatar>

      <div class="name-holder">
        <div *ngIf="user && (user.firstName || user.lastName)" class="full-width name">
          {{user?.firstName}} {{user?.lastName}}
        </div>
        <div *ngIf="user && !user.firstName && !user.lastName" class="full-width name">
          Unnamed User
        </div>
      </div>
    </div>

    <div class="change-password-block" fxLayout="row">
      <mat-spinner *ngIf="!user" diameter="30" class="center-align" color="primary"></mat-spinner>
      <span *ngIf="user && user.provider" class="text-disabled-color">
        <p i18n="User Profile|User profile social edit message@@user-profile-social-edit-message">
          First name, last name and password cannot be changed when signing in with {{user.provider}}.</p>
        <p i18n="User Profile|User profile social edit details@@user-profile-social-edit-details">
          You can change your name and password directly in your {{user.provider}} account.</p>
      </span>
      <form *ngIf="user && !user.provider" [formGroup]="changePassForm">
        <form-input [control]="oldPassField"
                    label="Current Password"
                    i18n-label="Change Password|Current password input label@@change-password-current-password-label"
                    placeholder="Current password..."
                    i18n-placeholder="Change Password|Current password input placeholder@@change-password-current-password-placeholder"
                    type="password"
                    suffixButton="visibility"
                    suffixButtonAlt="visibility_off"></form-input>
        <form-input [control]="passwordField"
                    label="Password"
                    i18n-label="Sign Up|Password input label@@sign-up-password-label"
                    placeholder="New password..."
                    i18n-placeholder="Change Password|New password input placeholder@@change-password-new-password-placeholder"
                    type="password"
                    suffixButton="visibility"
                    suffixButtonAlt="visibility_off"></form-input>
        <form-input [control]="confirmPassField"
                    [formGroup]="changePassForm"
                    [errorStateMatcher]="matcher"
                    label="Confirm Password"
                    i18n-label="Change Password|Confirm password input label@@change-password-confirm-password-label"
                    placeholder="Confirm password..."
                    i18n-placeholder="Change Password|Confirm password input placeholder@@change-password-confirm-password-placeholder"
                    type="password"
                    suffixButton="visibility"
                    suffixButtonAlt="visibility_off"></form-input>

        <div class="save-actions full-width">
          <div class="fill-space"></div>
          <app-button color="primary"
                      width="172px"
                      label="Change Password"
                      i18n-label="User Profile|Change Password button label@@user-profile-change-password-button-label"
                      [disabled]="!!dataLoadingProgress || changePassForm.invalid"
                      (clicked)="changePassword()"></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
